@if (superEjecutivo.abierto()) {
  <app-super-ejecutivo-panel [tamano]="tamanoPanel()" [area]="area()"></app-super-ejecutivo-panel>
}

@if (!(superEjecutivo.abierto() && tamanoPanel() === 'completo')) {
  <button mat-fab class="super-ejecutivo-boton" [class.super-ejecutivo-boton--angosto]="angosta()" (click)="alternarPanel()"
    [matTooltip]="superEjecutivo.abierto() ? 'Cerrar ' + nombre : 'Conversar con ' + nombre" matTooltipPosition="left"
    [attr.aria-label]="superEjecutivo.abierto() ? 'Cerrar ' + nombre : 'Conversar con ' + nombre">
    <mat-icon>{{ superEjecutivo.abierto() ? 'close' : 'smart_toy' }}</mat-icon>
    @if (!superEjecutivo.abierto()) {
      @if (superEjecutivo.propuestaPendiente()) {
        <span class="super-ejecutivo-indicador super-ejecutivo-indicador--propuesta" aria-label="Propuesta pendiente de autorizar">!</span>
      } @else if (superEjecutivo.respuestaNueva()) {
        <span class="super-ejecutivo-indicador super-ejecutivo-indicador--respuesta" [attr.aria-label]="nombre + ' respondió'"></span>
      }
    }
  </button>
}
